import { render, staticRenderFns } from "./FormationOfDecisionMakers.vue?vue&type=template&id=614bddd4&"
import script from "./FormationOfDecisionMakers.vue?vue&type=script&lang=ts&"
export * from "./FormationOfDecisionMakers.vue?vue&type=script&lang=ts&"
import style0 from "./FormationOfDecisionMakers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports